export default "/assets/webpack-assets/GT-Walsheim-Pro-Medium-Oblique.e7cf6496feb9670dfbe7ef50ca04e60b.woff";